import script from "./CourtReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtReservation.vue?vue&type=script&setup=true&lang=js"

import "./CourtReservation.vue?vue&type=style&index=0&id=4afe68da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4afe68da"]])

export default __exports__